import React from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {getUserData} from '../../../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {UpdateAssigneTo} from '../StaffProfileDetailSlice/StaffProfileDetailSlice'
import Select from 'react-select'

const ChangeAssignedUser = ({show, handleClose, list, setAssign}: any) => {
  const dispatch = useDispatch()
  const stafflist = useSelector((state: any) => state?.StaffAccount?.staffAccountList)
  const Role = useSelector(getUserData)?.data?.user?.role

  const handleChange = (e: any) => {
    // console.log(e, 'IIIIIIIIIIIII', val)
    // setAssign({...list, [name]: e.value})
  }

  const handleSubmit = () => {
    dispatch(UpdateAssigneTo(list))
    handleClose()
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-600px'
        className='vh-100 '
        size='sm'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          {Role == 'superAdmin' ? <h2>Assign Staff</h2> : <h2>Request Assign Staff</h2>}
        </div>
        <div className='modal-body p-12'>
          {/* <div className='col'>
              <label className=' col-form-label required fw-bold fs-6'>Type</label>

              <div className='row'>
                <div className='col fv-row'>
                  <input
                    name='Type'
                   
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder='Type'
                    // onChange={handleChange}
                  />
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block text-danger'></div>
                  </div>
                </div>
              </div>
            </div> */}
          <div className='col'>
            <label className=' col-form-label required fw-bold fs-6'>Account Manager2</label>

            <div className='row'>
              <div className='col fv-row'>
                <select
                  value={list?.accountManagerId}
                  name='accountManagerId'
                  onChange={handleChange}
                  className='form-select form-select-solid form-select-lg'
                >
                  <option>select</option>
                  {stafflist?.items?.map(
                    (key: any) =>
                      key?.role == 'accountManager' && (
                        <option key={key?._id} value={key?._id}>
                          {key?.name}
                        </option>
                      )
                  )}
                </select>
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
            </div>
          </div>
          <div className='col'>
            <label className=' col-form-label required fw-bold fs-6'>Sales</label>

            <div className='row'>
              <div className='col fv-row'>
                <select
                  value={list?.salesId}
                  name='salesId'
                  onChange={handleChange}
                  className='form-select form-select-solid form-select-lg'
                >
                  <option>select</option>
                  {stafflist?.items?.map(
                    (key: any) =>
                      (key?.role == 'sales' || key?.role == 'staffAdmin') && (
                        <option key={key?._id} value={key?._id}>
                          {key?.name}
                        </option>
                      )
                  )}
                </select>
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex flex-center mt-5'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={handleClose}
                className='btn btn-sm btn-light text-hover-white bg-white btn-active-primary text-primary me-2 w-100px p-3 fw-500 me-2'
              >
                Cancel
              </button>
            </div>

            <button
              type='submit'
              className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border border-primary'
              onClick={handleSubmit}
            >
              <span className='indicator-label'>Submit</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ChangeAssignedUser
